module.exports = __webpack_public_path__ + "img/01.13939eb8.jpg";